import { COMPANY } from "@/lib/company";
import { Link } from "react-router-dom";

interface Section {
  title: string;
  items: string[];
}

const SECTIONS: Section[] = [
  {
    title: "제1조 (목적)",
    items: [
      `이 약관은 ${COMPANY.name}(이하 "회사")가 제공하는 ${COMPANY.serviceName} 및 관련 제반 서비스(이하 "서비스")의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.`,
    ],
  },
  {
    title: "제2조 (정의)",
    items: [
      `"서비스"란 회사가 제공하는 숙소용 AI 게스트 컨시어지, 숙소 운영 관리(PMS), 채널 연동 등 일체의 기능을 말합니다.`,
      `"회원"이란 이 약관에 동의하고 관리자 계정을 등록하여 서비스를 이용하는 자를 말합니다.`,
      `"게스트"란 회원이 예약 건별로 발급한 전용 링크를 통해 별도의 가입 없이 챗봇 컨시어지를 이용하는 자를 말합니다.`,
      `"방문자"란 회원이 공개한 숙소 챗봇 링크를 통해, 예약 없이 그리고 별도의 가입 없이 챗봇에 문의하는 자를 말합니다. 예약 건별 전용 링크를 받는 게스트와 달리 회사는 방문자의 예약 정보나 연락처를 보유하지 않으며, 이 약관에서 게스트에 관한 조항은 성질에 반하지 않는 한 방문자에게도 적용됩니다.`,
      `"콘텐츠"란 회원이 서비스에 등록한 숙소 정보, 객실 정보, 가이드, FAQ, 예약 정보 등 일체의 정보를 말합니다.`,
    ],
  },
  {
    title: "제3조 (약관의 게시와 개정)",
    items: [
      "회사는 이 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면 하단에 게시합니다.",
      "회사는 「약관의 규제에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.",
      "회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 그 적용일자 7일 전부터 공지합니다. 다만, 회원에게 불리한 변경의 경우에는 30일 전부터 공지합니다.",
      "회원이 개정 약관의 적용일 이후에도 서비스를 계속 이용하는 경우 개정 약관에 동의한 것으로 봅니다.",
    ],
  },
  {
    title: "제4조 (이용계약의 체결 및 동의 간주)",
    items: [
      "이용계약은 서비스 이용을 원하는 자가 이 약관에 동의하고 계정 등록 또는 로그인을 완료함으로써 체결됩니다.",
      "회원이 서비스에 로그인하는 경우, 이 약관 및 개인정보 처리방침에 동의한 것으로 간주합니다.",
      "회사는 다음 각 호에 해당하는 경우 이용신청을 승낙하지 않거나 사후에 이용계약을 해지할 수 있습니다: 타인의 명의를 도용한 경우, 허위 정보를 기재한 경우, 관련 법령 또는 이 약관을 위반한 경우.",
    ],
  },
  {
    title: "제5조 (서비스의 제공 및 변경)",
    items: [
      "회사는 회원에게 게스트 챗봇 컨시어지, 예약·객실 관리, 가이드·FAQ 관리, 채널(OTA) 연동, 리포트 등의 서비스를 제공합니다.",
      "회사는 운영상·기술상 필요에 따라 제공하는 서비스의 전부 또는 일부를 변경할 수 있으며, 중대한 변경이 있는 경우 사전에 공지합니다.",
      "챗봇 답변은 회원이 등록한 콘텐츠를 근거로 인공지능이 생성하며, 회사는 답변의 완전성·정확성을 보증하지 않습니다. 중요한 안내 사항은 회원이 직접 확인·관리해야 합니다.",
    ],
  },
  {
    title: "제6조 (서비스의 중단)",
    items: [
      "회사는 시스템 점검·교체·고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스 제공을 일시적으로 중단할 수 있습니다.",
      "회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우 서비스 제공에 관한 책임이 면제됩니다.",
    ],
  },
  {
    title: "제7조 (회원의 의무)",
    items: [
      "회원은 계정 정보(이메일, 비밀번호 등)를 스스로 관리해야 하며, 이를 제3자에게 이용하게 해서는 안 됩니다.",
      "회원은 게스트의 개인정보를 관련 법령에 따라 적법하게 취급해야 하며, 서비스 이용 목적 외로 사용해서는 안 됩니다.",
      "회원은 다음 행위를 해서는 안 됩니다: 허위 정보의 등록, 타인의 정보 도용, 회사 및 제3자의 지식재산권 침해, 서비스의 정상적인 운영을 방해하는 행위, 관련 법령에 위반되는 행위.",
    ],
  },
  {
    title: "제8조 (콘텐츠의 권리와 책임)",
    items: [
      "회원이 서비스에 등록한 콘텐츠에 대한 권리와 책임은 회원에게 있습니다.",
      "회사는 서비스의 제공·운영·개선을 위해 필요한 범위에서 회원의 콘텐츠를 사용할 수 있습니다.",
      "회사는 회원의 콘텐츠가 관련 법령에 위반된다고 판단되는 경우 사전 통지 없이 삭제하거나 게시를 거부할 수 있습니다.",
    ],
  },
  {
    title: "제9조 (계약해지 및 이용제한)",
    items: [
      "회원은 언제든지 회사에 서비스 해지를 요청할 수 있으며, 회사는 관련 법령이 정하는 바에 따라 이를 처리합니다.",
      "회사는 회원이 이 약관 또는 관련 법령을 위반한 경우 서비스 이용을 제한하거나 이용계약을 해지할 수 있습니다.",
    ],
  },
  {
    title: "제10조 (손해배상 및 면책)",
    items: [
      "회사 또는 회원이 이 약관을 위반하여 상대방에게 손해를 입힌 경우 그 손해를 배상할 책임이 있습니다.",
      "회사는 무료로 제공하는 서비스의 이용과 관련하여 회원에게 발생한 손해에 대해서는 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.",
      "회사는 회원 간 또는 회원과 게스트, 회원과 제3자(OTA 등) 상호 간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며 이로 인한 손해를 배상할 책임이 없습니다.",
      "챗봇 답변은 회원이 등록한 콘텐츠를 근거로 인공지능이 생성하므로 오류나 최신성 결여가 있을 수 있으며, 회사는 답변의 정확성·완전성을 보증하지 않습니다. 게스트·방문자에 대한 최종 안내 책임은 해당 숙소를 운영하는 회원에게 있고, 회사는 챗봇 답변의 부정확·누락에 의존하여 게스트·방문자 또는 회원에게 발생한 손해에 대하여 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다.",
    ],
  },
  {
    title: "제11조 (준거법 및 재판관할)",
    items: [
      "회사와 회원 간에 발생한 분쟁에 대하여는 대한민국 법을 적용합니다.",
      "서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 민사소송법에 따른 관할 법원을 제1심 법원으로 합니다.",
    ],
  },
];

/** 이용약관 — 푸터 및 로그인 화면에서 링크됨. */
export function TermsPage() {
  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-12 sm:px-6 md:py-16">
      <header className="doc-head">
        <h1 className="doc-title">이용약관</h1>
        <p className="mt-4 text-base leading-relaxed text-muted-foreground">
          {COMPANY.serviceName} 서비스 이용에 적용되는 약관입니다. 서비스에 로그인하면 본 약관 및{" "}
          <Link to="/privacy" className="font-medium text-primary underline underline-offset-2">
            개인정보 처리방침
          </Link>
          에 동의하는 것으로 간주됩니다.
        </p>
      </header>

      <div className="mt-10 space-y-8">
        {SECTIONS.map((section) => (
          <section key={section.title} className="animate-rise">
            <h2 className="text-base font-semibold text-foreground">{section.title}</h2>
            <ol className="mt-2 list-decimal space-y-1.5 pl-5 text-sm leading-relaxed text-muted-foreground">
              {section.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ol>
          </section>
        ))}
      </div>

      <p className="mt-12 border-t border-border/60 pt-6 text-sm text-muted-foreground">
        부칙: 이 약관은 {COMPANY.termsEffectiveDate}부터 시행합니다.
      </p>
    </div>
  );
}
